import { connect } from '../../../../../../common/react-redux';
import QuizInstructionsEdit from './presenter';
function mapStateToProps(state, props) {
  return {
    appContainer: state.getIn(['ui', 'appContainer'])
  };
}
export default connect(mapStateToProps, null)(QuizInstructionsEdit);